export default "__VITE_ASSET__BH1ju55X__"